module.exports = __webpack_public_path__ + "img/credit.9a14b692.png";